import { createUseStyles } from "react-jss";
import { controlBackgroundColor, foregroundColor, getSpacing } from "../../theme/Mixins";

export default createUseStyles((theme: any) => ({
    scrollbars: {
        composes: "scrollbars",
        /* Override overflow from react-custom-scrollbars to allow overflow for dropdowns */
        overflow: "auto !important",
        "&::-webkit-scrollbar": {
            height: "8px",
        },
        "&::-webkit-scrollbar-track": {
            background: "#f1f1f1",
        },
        "&::-webkit-scrollbar-thumb": {
            background: "#888",
        },
        "&::-webkit-scrollbar-button": {
            display: "none",
        },
    },
    scrollable: {
        composes: "scrollable",
        margin: ({ theme }) => [[getSpacing(theme, 0, theme.QuestionSpacing?.WithinComponents), 0]],
        position: "relative",
    },
    scrollableWindow: {
        composes: "scrollable__window",
        display: "flex",
        overflow: "auto !important",
        margin: "0 !important",
    },
    scrollTrackHorizontal: {
        left: 29,
        right: 29,
        zIndex: "auto",
        bottom: 0,
        height: "16px !important",
        transition: "opacity 200ms",
    },
    scrollThumbHorizontal: {
        borderRadius: 3,
        background: theme.ControlBorderColor,
        height: "6px !important",
        top: 5,
        transition: "height 100ms, border-radius 100ms, top 100ms",
    },
    scrollThumbHorizontalActive: {
        borderRadius: 8,
        top: 0,
        height: "16px !important",
    },
    scrollableChild: {
        composes: "scrollable__child",
        width: "100%",
    },
    indicator: {
        position: "absolute",
        top: "50%",
        cursor: "pointer",
        zIndex: 10,
        opacity: 0.5,
        fontSize: 30,
        transition: "opacity 0.3s",
        "&:hover": {
            opacity: 1,
        },
    },
    indicatorLeft: {
        composes: "scrollable__scroll-indicator--left",
        left: 10,
        position: "absolute",
    },
    indicatorRight: {
        composes: "scrollable__scroll-indicator--right",
        right: 10,
        position: "absolute",
    },
    indicatorHidden: {
        composes: "scrollable__scroll-indicator--hidden",
        display: "none",
    },
    icon: {
        composes: "scrollable__scroll-indicator__icon",
        color: foregroundColor(theme, controlBackgroundColor(theme)),
    },
}));
